import { render, staticRenderFns } from "./MenuNode.vue?vue&type=template&id=33733076&"
import script from "./MenuNode.vue?vue&type=script&lang=js&"
export * from "./MenuNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports